module.exports = __webpack_public_path__ + "files/bourgain.efb9db3e58ffd37848daad65c3ab2399.pdf";